import {tabSession} from './session';
import {serverCredential} from './credential';
import type {LoginCandidate, SessionOperation} from './tabSession';

export type RequestSession = SessionOperation & {readonly candidate?: LoginCandidate};

export function captureRequestSession(candidate?: LoginCandidate): RequestSession {
    return candidate ? {...candidate, candidate} : tabSession.captureRequest();
}

/** The credential our server checks for this session (see `serverCredential`). */
export async function requestServerCredential(session: RequestSession): Promise<string> {
    session.assertCurrent();
    if (session.candidate) return serverCredential(session.candidate.credentials);
    const credentials = await tabSession.credentials(session);
    session.assertCurrent();
    return serverCredential(credentials);
}
